export const exclusionFields = [
    { label: 'Description', value: 'description' },
    // { label: 'Merchant Name', value: 'merchant_name' },
    // { label: 'Amount', value: 'amount' },
    // { label: 'Day of week', value: 'day_of_week' },
    // { label: 'Day of Month', value: 'day_of_month' },
    // { label: 'Currency', value: 'currency' },
];
